import React from 'react';
import { Container } from 'flux/utils';
import { ActiveFilters } from './filters';
import { Creators, ActiveStore } from 'model';

function getStores() {
	return [ ActiveStore ]
}

function calcState() {
	var state = ActiveStore.getState();
	return {
		filters: state.filters,
		onClick: Creators.removeFilter
	};
}

export default Container.createFunctional(ActiveFilters, getStores, calcState);


// WEBPACK FOOTER //
// ./src/modules/app/CurrentFilters.js